export class LoginData {
  usernameOrEmail = ''; // need to define defaults for the form builder
  password = '';
  emailAddress = '';
}
